import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import "./index.scss";

import React, { useEffect, useState } from "react";

import Spinner from "components/spinner";
import { formatDate } from "helper/dateFormat";
import moment from "moment";
import { toastr } from "react-redux-toastr";
import { Charge } from "./Charge";
import { Donation } from "./Donation";
import { Payment } from "./Payment";
const FinanceDrawer = ({
  data,
  setsavetribute,
  setTributeList,
  batchTable,
  onReversalClick,
  viewDocumentHandler,
  downloadFileHandler,
  documentHandler,
  onSharePaymentLinkClick,
  viewLetterHandler,
  ...props
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [invoiceData, setInvoiceData] = useState("");
  const [receiptData, setReceiptData] = useState("");
  const [donationDonarData, setDonationDonarData] = useState("");
  const [donationRecipientData, setDonationRecipientData] = useState("");
  const fetchMyAPI = async (id, type) => {
    const token = await getAccessTokenSilently();
    await FinanceService.getDocumentByTransactionId(token, id, type)
      .then((res) => {
        const result = res?.result?.[0];
        if (type === "invoice") {
          setInvoiceData(result);
        }
        if (type === "receipt") {
          setReceiptData(result);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const fetchDonationLetterApi = async (
    id,
    type = "donationDonar",
    action = "view"
  ) => {
    const token = await getAccessTokenSilently();
    const data = {
      id: id,
      type: type,
      action: action,
    };
    await FinanceService.getDonationLetterByTransactionId(token, data)
      .then((res) => {
        const result = res?.content;
        if (type === "donationDonar") {
          setDonationDonarData(result);
        }
        if (type === "donationRecipient") {
          setDonationRecipientData(result);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  const fetchDownloadDonationLetterApi = async (
    id,
    type = "donationDonar",
    action = "download"
  ) => {
    const token = await getAccessTokenSilently();
    const bodyData = {
      id: id,
      type: type,
      action: action,
    };
    const accountName = data?.Account?.name;
    await FinanceService.downloadDonationLetterByTransactionId(token, bodyData)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const currentDate = formatDate({
          date: new Date(),
          formatType: "defaultWithUTC",
        });
        const fileType =
          type === "donationDonar" ? "donor_letter" : "recipient_letter";
        const fileName = `${fileType}_${accountName.replaceAll(
          " ",
          "_"
        )}_${currentDate}`;
        link.setAttribute("download", `${fileName}.pdf`);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  useEffect(() => {
    const { status } = data?.charge || {};
 
    if (status === "payment") {
      fetchMyAPI(data?.transactionId || data?._id, "invoice");
      fetchMyAPI(data?.charge?._id, "receipt");
    }

    if (data.charge_type === "donation" && !data?.isBulkPayment) {
      fetchDonationLetterApi(
        data?.transactionId || data?._id,
        "donationDonar",
        "view"
      );
      if (data?.tribute_info?.is_filled) {
        fetchDonationLetterApi(
          data?.transactionId || data?._id,
          "donationRecipient",
          "view"
        );
      }
    }
  }, [data?.charge?.status, data?.tribute_info]);

  const downloadFileClickHandler = (type) => {
    if (type === "invoice") {
      downloadFileHandler(invoiceData);
    }
    if (type === "receipt") {
      downloadFileHandler(receiptData);
    }
  };

  const viewFileClickHandler = (type) => {
    if (type === "invoice") {
      viewDocumentHandler(invoiceData?._id);
    }
    if (type === "receipt") {
      viewDocumentHandler(receiptData?._id);
    }
  };

  const sharedFileClickHandler = (type) => {
    if (type === "invoice") {
      documentHandler(invoiceData);
    }
    if (type === "receipt") {
      documentHandler(receiptData);
    }
  };

  const viewDonationLetterHandler = (type) => {
    if (type === "donationDonar") {
      viewLetterHandler(donationDonarData);
    }
    if (type === "donationRecipient") {
      viewLetterHandler(donationRecipientData);
    }
  };

  const downloadDonationLetterHandler = (type) => {
    fetchDownloadDonationLetterApi(data?.transactionId || data?._id, type, "download");
  };

  return (
    <div className="finance-drawer">
      {loading ? (
        <Spinner />
      ) : (data?.charge_type === "charge" &&
          data?.charge?.status === "payment") ||
        data?.bulkPaymentFlag ? (
        <Payment
          batchTable={batchTable}
          data={data}
          onReversalClick={onReversalClick}
          downloadFileClickHandler={downloadFileClickHandler}
          viewFileClickHandler={viewFileClickHandler}
          sharedFileClickHandler={sharedFileClickHandler}
          hideInvoiceButtons={!invoiceData}
          hideReceiptButtons={!receiptData}
          {...props}
        />
      ) : data?.charge_type === "credit_on_account" &&
        data?.charge?.status === "payment" ? (
        <Payment
          batchTable={batchTable}
          data={data}
          onReversalClick={onReversalClick}
          downloadFileClickHandler={downloadFileClickHandler}
          viewFileClickHandler={viewFileClickHandler}
          sharedFileClickHandler={sharedFileClickHandler}
          hideInvoiceButtons={!invoiceData}
          hideReceiptButtons={!receiptData}
          {...props}
        />
      ) : data?.isExpandRow && data?.charge_type === "donation" ? (
        <Payment
          batchTable={batchTable}
          data={data}
          onReversalClick={onReversalClick}
          downloadFileClickHandler={downloadFileClickHandler}
          viewFileClickHandler={viewFileClickHandler}
          sharedFileClickHandler={sharedFileClickHandler}
          hideInvoiceButtons={!invoiceData}
          hideReceiptButtons={!receiptData}
          {...props}
        />
      ) : data?.charge_type === "donation" ? (
        <Donation
          batchTable={batchTable}
          data={data}
          setsavetribute={setsavetribute}
          setTributeList={setTributeList}
          onReversalClick={onReversalClick}
          downloadFileClickHandler={downloadFileClickHandler}
          viewFileClickHandler={viewFileClickHandler}
          viewDonationLetterHandler={viewDonationLetterHandler}
          downloadDonationLetterHandler={downloadDonationLetterHandler}
          sharedFileClickHandler={sharedFileClickHandler}
          hideInvoiceButtons={!invoiceData}
          hideReceiptButtons={!receiptData}
          {...props}
        />
      ) : data?.charge_type === "credit_on_account" ? (
        <Charge
          batchTable={batchTable}
          data={data}
          onReversalClick={onReversalClick}
          onSharePaymentLinkClick={onSharePaymentLinkClick}
          {...props}
        />
      ) : (
        <Charge
          batchTable={batchTable}
          data={data}
          onReversalClick={onReversalClick}
          onSharePaymentLinkClick={onSharePaymentLinkClick}
          {...props}
        />
      )}
    </div>
  );
};
export default FinanceDrawer;
